import React, { Component } from 'react';
import propTypes from 'prop-types';
import axios from 'axios';
import MapsAPI from '../../../google'
import ApiConfig from '../../../config'

export default class ModuleLocation extends Component {


  geocodeThis = () => {
    delete axios.defaults.headers.common["Authorization"];


    let coords = '';

    let geoCodeURL


    if (addr1) {addr1 = '';}
    if (addr2) {addr2 = ''}
    if (city) {city = '';}
    if (zip) {zip = '';}
    if (streetAddress) {streetAddress = '';}
    if (geoCodeURL) {geoCodeURL = '';}

    let addr1;
    let addr2
    let city;
    let zip;
    let streetAddress;

    if (this.props.currentRecord['Address 1']) {addr1 = this.props.currentRecord['Address 1']}
    if (this.props.currentRecord['City']) {city = this.props.currentRecord['City']}
    if (this.props.currentRecord['Zip']) {zip = this.props.currentRecord['Zip']}

    if (addr1) {
      streetAddress = addr1;
      if (city) {streetAddress = streetAddress + ' ' + city + ' Florida';} else {streetAddress = streetAddress + ' Florida';}
      if (zip) {streetAddress = streetAddress + ' ' + zip;}
    }

    geoCodeURL = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURI(streetAddress) + '&key=' + MapsAPI();
    axios
      .get(geoCodeURL)
      .then(response => {
        console.log(response);
        coords = parseFloat(response.data.results[0].geometry.location.lat) + ', ' + parseFloat(response.data.results[0].geometry.location.lng)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + ApiConfig();

        this.props.saveCoords(coords);
      });
  }
  // Render
  // ----------------------------------------------------
  render() {
    let addr1 = this.props.addr1;
    let addr2 = this.props.addr2;
    let city = this.props.city;
    let zip = this.props.zip;
    let county = this.props.county;
    let emp = this.props.emp;
    let company = this.props.company;

    let validateAddress;
    if (company && addr1) {
      let totalAddress = company.replace(/ /g, '+') + '+' + addr1;
      if (addr2) {totalAddress = totalAddress + addr2;}
      if (city) {totalAddress = totalAddress + ', ' + city + ', Florida';} else {totalAddress = totalAddress + ', Florida';}
      if (zip) {totalAddress = totalAddress + ', ' + zip;}
      validateAddress = 'https://www.google.com/maps/search/?api=1&query=' + encodeURI(totalAddress);
    }

    let coords = '';

    if (this.props.currentRecord && this.props.currentRecord['Coordinates']) {
      coords = ' (' + this.props.currentRecord['Coordinates'] + ')';
    }


    return (
      <div className="ModuleCard moduleLocation">
        <div className="inner">

          <div className="inputBlock inputBlock--large">
            <label>Address 1</label>
            <input
              type="text"
              value={addr1}
              id="addr1"
              onChange={this.props.changeRecordHandler}
            />
          </div>
          <div className="inputBlock inputBlock--small">
            <label>Address 2</label>
            <input
              type="text"
              value={addr2}
              id="addr2"
              onChange={this.props.changeRecordHandler}
            />
          </div>

          <div className="inputBlock inputBlock--half">
            <label>City</label>
            <input
              type="text"
              value={city}
              id="city"
              onChange={this.props.changeRecordHandler}
            />
          </div>
          <div className="inputBlock inputBlock--half">
            <label>Zip</label>
            <input
              type="text"
              value={zip}
              id="zip"
              onChange={this.props.changeRecordHandler}
            />
          </div>

          <div className="inputBlock inputBlock--half">
            <label>County</label>
            <input
              type="text"
              value={county}
              id="county"
              onChange={this.props.changeRecordHandler}
            />
          </div>
          <div className="inputBlock inputBlock--half">
            <label>Employees</label>
            <input
              type="text"
              value={emp}
              id="emp"
              onChange={this.props.changeRecordHandler}
            />
          </div>

          <div className="cardTag">
            <a className="btn softGrad--secondary" href={validateAddress} target="_blank">View on Map</a>
          </div>
        </div>
        <a className="" onClick={()=>this.geocodeThis()} target="_blank">GeoCode This{coords}</a>
      </div>
    );
  }
}

ModuleLocation.propTypes ={
  addr1: propTypes.string,
  addr2: propTypes.string,
  company: propTypes.string,
  city: propTypes.string,
  zip: propTypes.string,
  county: propTypes.string,
  emp: propTypes.string,
  changeRecordHandler: propTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/CustomerService/Records/Modules/ModuleLocation.js